import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  CheckoutCompleteResp,
  CheckoutNumberInfo,
  CheckoutReq,
  PaymentCompletedReq,
  PaymentIntent,
  PaymentStatus,
  ProvisionReq
} from './voucher.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { X_B3_HEADER } from '@b3networks/shared/common';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  constructor(private http: HttpClient) {}

  checkout(req: CheckoutReq): Observable<PaymentIntent> {
    return this.http.post<PaymentIntent>(`/shopify/v1/checkout`, req).pipe(map(p => new PaymentIntent(p)));
  }

  getPaymentStatus(checkoutToken: string): Observable<PaymentStatus> {
    const params = new HttpParams().set('token', checkoutToken);
    return this.http.get<PaymentStatus>(`/shopify/v1/checkout/status`, { params: params });
  }

  submitOrder(req: PaymentCompletedReq): Observable<CheckoutCompleteResp> {
    return this.http.post<CheckoutCompleteResp>(`/shopify/v1/checkout/complete`, req);
  }

  provision(req: ProvisionReq) {
    return this.http.post(`license/private/shopify/v1/provision`, req);
  }

  getAvailableNumbers(orderToken: string): Observable<CheckoutNumberInfo[]> {
    return this.http.get<CheckoutNumberInfo[]>(`license/private/shopify/v1/orders/numbers?token=${orderToken}`);
  }

  getOrderInfo(orderToken: string, orgUuid?: string): Observable<PaymentIntent> {
    let headers = new HttpHeaders();
    if (orgUuid) {
      headers = headers.append(X_B3_HEADER.orgUuid, orgUuid);
    }
    const params = new HttpParams().set('token', orderToken);
    return this.http
      .get<PaymentIntent>(`/shopify/v1/orders`, { params: params, headers: orgUuid ? headers : null })
      .pipe(map(p => new PaymentIntent(p)));
  }
}
